export default {"PACKAGE_VERSION": "2.1.222547.0 (e0768a17)","UI_THEME": "polaris"}